import classNames from 'classnames';
import Image from '../../Atoms/Image';

interface Props {
  imageSrc: string;
  theme?: 'dark' | 'light';
  reverse?: boolean;
  children: JSX.Element | JSX.Element[];
}

function CardSimple({
  imageSrc,
  theme = 'light',
  reverse,
  children
}: Props) {
  return (
    <div className="w-full @container">
      <div
        className={classNames([
          'mx-auto flex w-full flex-col-reverse justify-between gap-7 @xs:max-w-lg @3xl:max-w-full ',
          theme === 'dark' &&
            'rounded-xl bg-sl-blue p-7 text-white @3xl:p-14',
          theme === 'light' && 'bg-white text-sl-blue',
          reverse && '@3xl:flex-row-reverse',
          !reverse && '@3xl:flex-row'
        ])}
      >
        <div className="flex w-full max-w-md flex-col items-start gap-3.5 self-center @3xl:w-1/2 @5xl:w-8/12 @5xl:max-w-xl">
          {children}
        </div>
        <div className="flex w-full max-w-md items-start justify-center @3xl:w-1/2 @5xl:w-4/12 @5xl:max-w-full">
          <Image src={imageSrc} rounded shadow />
        </div>
      </div>
    </div>
  );
}

export default CardSimple;
